module.exports = __webpack_public_path__ + "img/story038@2x.6bad4ed9.webp";